var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "136 -824 688 688",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.79-309.54q8.67 0 14.75-5.86 6.08-5.87 6.08-14.54 0-8.68-5.87-14.75-5.87-6.08-14.54-6.08t-14.75 5.87q-6.08 5.86-6.08 14.54 0 8.67 5.87 14.74 5.87 6.08 14.54 6.08M464-425.85h32v-240h-32zM480.41-136q-70.95 0-133.69-26.84-62.73-26.84-109.86-73.92t-73.99-109.72Q136-409.11 136-480.32q0-71.22 26.84-133.46 26.84-62.23 73.92-109.36t109.72-73.99Q409.11-824 480.32-824q71.22 0 133.46 26.84 62.23 26.84 109.36 73.92t73.99 109.48Q824-551.36 824-480.41t-26.84 133.69q-26.84 62.73-73.92 109.86t-109.48 73.99Q551.36-136 480.41-136m-.41-32q130 0 221-91t91-221-91-221-221-91-221 91-91 221 91 221 221 91m0-312"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.5626ea4ec6dc395c9c3fd57e66c9b2f0.svg";
export { ForwardRef as ReactComponent };